export default {
    DEBOUNCE_DELAY: 250
};